import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { useAuth } from '../contexts/AuthContext';

function fmtDate(d) {
  if (!d) return '';
  const dt = new Date(d);
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) +
    ' · ' + dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

export default function BulkCampaignList() {
  const navigate = useNavigate();
  const { selectedBusiness } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!selectedBusiness?.id) return;
    setLoading(true);
    api.get('/campaigns/bulk-list', { params: { business_id: selectedBusiness.id } })
      .then(r => { setRows(r.data || []); setError(null); })
      .catch(e => setError(e.response?.data?.error || 'Failed to load campaigns'))
      .finally(() => setLoading(false));
  }, [selectedBusiness]);

  if (loading) return <div style={{ padding: '2rem' }}>Loading campaigns...</div>;
  if (error) return <div style={{ padding: '2rem', color: '#dc2626' }}>{error}</div>;

  return (
    <div style={{ padding: '1.5rem 2rem' }}>
      <h2 style={{ margin: '0 0 4px', fontSize: 20, fontWeight: 600 }}>Bulk Campaigns</h2>
      <p style={{ margin: '0 0 20px', fontSize: 13, color: '#6b7280' }}>Manual bulk WhatsApp campaigns you've sent</p>

      {rows.length === 0 ? (
        <p style={{ color: '#6b7280' }}>No bulk campaigns yet.</p>
      ) : (
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
          <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fb', textAlign: 'left' }}>
                <th style={{ padding: '10px 14px', color: '#6b7280', fontWeight: 500 }}>Campaign</th>
                <th style={{ padding: '10px 14px', color: '#6b7280', fontWeight: 500 }}>Template</th>
                <th style={{ padding: '10px 14px', color: '#6b7280', fontWeight: 500 }}>Date</th>
                <th style={{ padding: '10px 14px', color: '#6b7280', fontWeight: 500, textAlign: 'right' }}>Sent</th>
                <th style={{ padding: '10px 14px', color: '#6b7280', fontWeight: 500, textAlign: 'right' }}>Delivered</th>
                <th style={{ padding: '10px 14px', color: '#6b7280', fontWeight: 500, textAlign: 'right' }}>Read</th>
                <th style={{ padding: '10px 14px', color: '#6b7280', fontWeight: 500, textAlign: 'right' }}>Failed</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr
                  key={row.id}
                  onClick={() => navigate(`/bulk-campaign-report/${row.id}`)}
                  style={{ cursor: 'pointer', borderTop: '1px solid #f1f1f1' }}
                  onMouseOver={e => e.currentTarget.style.background = '#f8f9fb'}
                  onMouseOut={e => e.currentTarget.style.background = 'transparent'}
                >
                  <td style={{ padding: '10px 14px', fontWeight: 500 }}>{row.campaign_name}</td>
                  <td style={{ padding: '10px 14px', color: '#6b7280' }}>{row.template_name}</td>
                  <td style={{ padding: '10px 14px', color: '#6b7280' }}>{fmtDate(row.schedule_time)}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right' }}>{row.sent_count}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#16a34a' }}>{row.delivered_count}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right' }}>{row.read_count}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: row.failed_count > 0 ? '#dc2626' : '#6b7280' }}>{row.failed_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
